import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, CheckCircle2, CircleAlert } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const ProviderAssignmentsList = () => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/providers/me/assignments").then((r) => setItems(r.data)).catch((e) => setError(formatApiError(e)));
  }, []);
  if (error) return <p className="form-message error-message" data-testid="provider-assignments-error">{error}</p>;
  if (!items) return <p className="projection-loading">Loading…</p>;
  if (!items.length) return <p className="muted" data-testid="provider-assignments-empty">No assignment emails yet.</p>;
  return (
    <section className="provider-assignments-list" data-testid="provider-assignments-list">
      {items.map((item) => (
        <Link className={`provider-week-item ${item.needs_confirmation ? "needs-confirmation" : ""}`} data-testid={`provider-assignment-${item.id}`} key={item.id} to={`/provider-portal/assignments/${item.id}`}>
          <div><strong><Briefcase size={14} /> {item.role_name} · {item.client_name}</strong><span>Starts {item.start_label}{item.documents_to_acknowledge ? ` · ${item.documents_to_acknowledge} document${item.documents_to_acknowledge === 1 ? "" : "s"} to read` : ""}</span></div>
          <em>{item.needs_confirmation ? <><CircleAlert size={13} /> {item.updated ? "Updated · confirm" : "Confirm"}</> : <><CheckCircle2 size={13} /> Confirmed</>}</em>
        </Link>
      ))}
    </section>
  );
};
